<div *ngFor="let duplicate of duplicates">
  <div *ngIf="!duplicate.multiAccount">
    <se-fe-banner *ngIf="!duplicate.dismissed && ( !persona || persona.firstLast === duplicate.name )"
      class="duplicate-row"
      [seFeDataTitle]="'DUPLICATE_BANNER.title' | translate: {first_name: duplicate.personas[0].first_name }"
      seFeDataType="warning"
      [seFeShowIcon]="false">
      <span seFeBannerSubtitle>{{ 'DUPLICATE_BANNER.subtitle' | translate}}</span>
      <se-fe-button seFeBannerAction
        class="first-button"
        seFeDataEmphasis="high"
        (click)="openMergeModal(duplicate)">
      Yes
      </se-fe-button>
      <se-fe-button seFeBannerAction
        [seFeDataEmphasis]="'medium'"
        (click)="dismissBanner(duplicate)">
        No
      </se-fe-button>
    </se-fe-banner>
  </div>
</div>
<app-profile-merge-modal [keepPersona]="keepPersona" [mergePersona]="mergePersona" description="from_banner" (successfulMerge)="onSuccessfulMerge()" #profileMergeModal></app-profile-merge-modal>
